/* eslint-disable consistent-return */

import { AccountInfo, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { toast } from 'react-toastify';
import logoff from '../services/logoff';
import store from '../store';
import enviroments from '../enviroments';

export const config = {
  appId: 'b98527e3-ae89-4a15-8d24-e67b9d7c9f8a',
  redirectUri: enviroments.URL_ADMIN,
  clientSecret: 'e055a62d-a720-4381-86c8-0cc912ac1b6d',
  scopes: [
    'user.read', 'email', 'offline_access',
  ],
  authority: 'https://login.microsoftonline.com/bb24ffdd-87d9-46b8-9d3f-d8bf25bd0ef1',
};

export const data = new PublicClientApplication({
  auth: {
    clientId: config.appId,
    redirectUri: config.redirectUri,
    authority: config.authority,
  },
  cache: {
    secureCookies: true,
  },
});

export const refreshTokenAzure = async () => {
  try {
    const { login } = store.getState().user;

    const currentAccount: AccountInfo | null = data?.getAccountByUsername(login);

    if (currentAccount === null) {
      toast.error('Atenção!\nUsuário não encontrado.');
      logoff();
      return;
    }
    const silentRequest: SilentRequest = {
      scopes: ['Mail.Read'],
      account: currentAccount || undefined,
      forceRefresh: false,
    };

    const tokenResponse = await data.acquireTokenSilent(silentRequest);
    return tokenResponse.accessToken;
  } catch (error) {
    toast.error('Atenção!\nNão foi possível renovar sua sessão, faça o login novamente.');
  }
};
